import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class RetrieveTokenExInfoController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.cartConfig = cartConfig;
    $ctrl.token = options.token;
	$ctrl.expiration = options.expiration;
    $ctrl.cvv = options.cvv;
		$ctrl.title = options.title || "Token Information";
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.loadTokenEx();
        // $ctrl.bus.read('RetrieveTokenExInfo.json?Token=' + $ctrl.token).then(res=> {
        //     $ctrl.tokenInfo = res.data;
        // });
	}
	loadTokenEx() {
		let $ctrl = this;
		$ctrl.bus.send("TokenEx/GenerateAuthenticationKey", {Token: $ctrl.token}).then(function(res) {
		  $ctrl.iframeConfig = {
			origin: $ctrl.cartConfig.tokenExOrigin,
			timestamp: res.data.timestamp,
			tokenExID: $ctrl.cartConfig.tokenExId,
			authenticationKey: res.data.key,
			pci: true,
			enablePrettyFormat: true,
			token: $ctrl.token,
			title: "Card Number",
			//        cvvTitle: "CVV",
			inputType: "text",
			styles: {
				base: "font-family: Arial, sans-serif;padding: 0 8px;border: 1px solid rgba(0, 0, 0, 0.2);margin: 0;width: 100%;font-size: 13px;line-height: 30px;height: 32px;box-sizing: border-box;-moz-box-sizing: border-box;",
				focus: "box-shadow: 0 0 6px 0 rgba(0, 132, 255, 0.5);border: 1px solid rgba(0, 132, 255, 0.5);outline: 0;",
				error: "box-shadow: 0 0 6px 0 rgba(224, 57, 57, 0.5);border: 1px solid rgba(224, 57, 57, 0.5);",
			}
		};
		  $ctrl.iframe = new TokenEx.DetokenizeIframe("tokenExIframeDiv", $ctrl.iframeConfig);
		  $ctrl.iframe.load();
		});
	  }
	}
